import React from "react";
import axios from 'axios';
import CommonInspringStoryPhoto from "./CommonInspringStoryPhoto";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

class InspiringStorySection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            inspiringStoriesDataList: [],
            responseMessage: ''
        }
    }

    componentDidMount(){
        this.getAllInspiringStoriesData();
    }


    getAllInspiringStoriesData = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/backend/pre/login/inspiringStories/getPublicList?page=${this.state.page}&size=${this.state.size}&loginType=PRE_LOGIN`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                    this.setState({
                        inspiringStoriesDataList: response?.data?.body?.content,
                        responseMessage: response.data?.message
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    getInspiringStoriesData = () => {
        return this.state.responseMessage === 'Success!' ? 
            <div className='col-lg-6 imgWrap'>
                {this.state.inspiringStoriesDataList && this.state.inspiringStoriesDataList.length > 0 && this.state.inspiringStoriesDataList.slice(0,2).map((inspiringStory,index) => {
                    return  <CommonInspringStoryPhoto item={inspiringStory?.link} title={inspiringStory?.title} key={index} />
                })}
            </div> : 

        <div className='col-lg-6 imgWrap'>
            {Array(2).fill().map((item, index) => (
                <figure className="skeletonBlk" key={index}>
                    <Skeleton  height={"100%"} width={"100%"}/>
                </figure>
                    
            ))}
        </div>

    }

    render() {
        const{ inspiringStoriesDataList } = this.state;

        return (
            <section className='lndInspireStory sectionLndAll'>
                <div className='row align-items-center'>
                    {/* <div className='col-lg-6 imgWrap'> */}
                        {this.getInspiringStoriesData()}
                        {/* {inspiringStoriesDataList && inspiringStoriesDataList.length > 0 && inspiringStoriesDataList.slice(0,2).map((inspiringStory,index) => {
                            return  <CommonInspringStoryPhoto item={inspiringStory?.link} title={inspiringStory?.title} key={index} />
                        })} */}
                        
                    {/* </div> */}
                    <div className='col-lg-6'>
                        <h2>Inspiring Stories</h2>
                        <h5>"Stories of Extraordinary Individuals"</h5>
                        <p>Amidst magnificent landscapes and awe-inspiring beauty of nature, incredible individuals have emerged as beacons of
                            inspiration. These are the untold stories of people who have embraced a distinct approach towards nature , demonstrating
                            unwavering determination, courage, and compassion in their quest to protect and preserve the natural world.</p>
                    </div>
                </div>
            </section>
        );
    }
}

export default InspiringStorySection;